module.exports = __webpack_public_path__ + "img/alentour10.c834921f.jpg";